import React, {useState} from 'react';
import {Toast} from '../../../../utils/sweetAlert';
import {t} from 'react-switch-lang';
import Form from 'reactstrap/lib/Form';
import Button from 'reactstrap/lib/Button';
import {
  deleteExternalizationDocumentTemplates
} from '../../../../services/externalizations/externalizationTemplatesServices';

const DeleteExternalizationTemplates = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleSubmit = (event) => {
    setIsButtonDisabled(true);
    event.preventDefault();
    deleteExternalizationDocumentTemplates(props?.data?.id)
      .then((res) => {
        Toast.fire({
          icon: "success",
          title: `${t("message.successDelete")}`,
        });
        props.setRowChanged();
        props.toggleModal();
        setIsButtonDisabled(false);
      })
      .catch((r) => {
        console.log('error');});
  };
  return (
    <Form
      onSubmit={(e) => handleSubmit(e)}
      noValidate
      className="d-flex justify-content-between">
      <Button className="primary deleteButton" disabled={isButtonDisabled}>
        {t("buttons.deleteBtn")}{" "}
      </Button>
    </Form>
  );
};

export default DeleteExternalizationTemplates;